import { memo } from 'react'
import { Quote } from 'lucide-react'
import type { ChatAttachment, FinalizedAttachment } from '../../../../types'
import { FadingScrollable } from '../../../elements/FadingScrollable'
import { PreviewableContext } from '../../input/context/previewable-context'
import { AttachmentStub } from '../attachment-stub'
import { useRemoveAttachment } from '../hooks/use-remove-attachment'
import { scrollableAreaClassName, scrollablePreviewClassName } from '../styles'
import type { AttachmentPillProps } from '../types'

export const QuoteReference = memo((attachment: AttachmentPillProps) => {
  const onRemove = useRemoveAttachment(attachment)

  return (
    <PreviewableContext preview={<QuoteReferencePreview {...attachment} />}>
      <AttachmentStub label={'Quote'} icon={<Quote size={16} />} onRemove={onRemove} />
    </PreviewableContext>
  )
})
QuoteReference.displayName = 'QuoteReference'

const QuoteReferencePreview = memo((attachment: ChatAttachment) => {
  const quote = attachment.attachment as Extract<FinalizedAttachment, { type: 'quoteReference' }>
  return (
    <div className={scrollablePreviewClassName}>
      <FadingScrollable className={scrollableAreaClassName} onClick={(e) => e.stopPropagation()}>
        {quote.text}
      </FadingScrollable>
    </div>
  )
})
QuoteReferencePreview.displayName = 'QuoteReferencePreview'
